import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
const iconStyle = {
    padding: 0,
    pl: '3px',
    pr: '3px',
    fontSize: '1.3rem',
    mt: '4px',
    width: '34px',
};
const languages = [
    {
        code: 'en',
        label: 'English',
    },
    {
        code: 'pl',
        label: 'Polski',
    },
    {
        code: 'ru',
        label: 'Русский',
    },
    {
        code: 'uk',
        label: 'Українська',
    },
];
// Простой маппер для красивого отображения в хедере
const displayCodes = {
    uk: 'UA',
    en: 'EN',
    ru: 'RU',
    pl: 'PL'
};
export default function LanguageSwitcher({ languageHref, onLanguageNavigate } = {}) {
    const { i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const currentLanguage = i18n.language;
    // Получаем красивый код (UA, EN, PL, RU), если язык содержит подтеги (например, uk-UA), берем первую часть
    const baseLangCode = currentLanguage.split('-')[0];
    const displayText = displayCodes[baseLangCode] || baseLangCode.toUpperCase();
    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const changeLanguage = (code) => {
        i18n.changeLanguage(code);
        handleClose();
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, Object.assign({ sx: iconStyle, onClick: handleOpen }, { children: _jsx(Box, Object.assign({ component: "span" }, { children: displayText })) })), _jsx(Menu, Object.assign({ anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleClose }, { children: languages.map((lang) => (_jsxs(MenuItem, Object.assign({ component: languageHref ? 'a' : 'li' }, (languageHref ? { href: languageHref(lang.code) } : {}), { selected: baseLangCode === lang.code, onClick: (event) => {
                        if (!languageHref) {
                            changeLanguage(lang.code);
                            return;
                        }
                        if (onLanguageNavigate && event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
                            event.preventDefault();
                            onLanguageNavigate(lang.code);
                        }
                        handleClose();
                    } }, { children: [_jsx(Box, { component: "span", sx: { mr: 1 } }), " ", lang.label] }), lang.code))) }))] }));
}
